import { Routes } from '@angular/router';
import { MainLayout } from './layouts/main-layout/main-layout';

export const routes: Routes = [
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
        title: 'CESCOG | Accueil',
      },
      {
        path: 'tarifs',
        loadComponent: () => import('./pages/rates/rates').then((m) => m.Rates),
        title: 'CESCOG | Tarifs',
      },
      {
        path: 'recherche-clinique',
        loadComponent: () => import('./pages/research/research').then((m) => m.Research),
        title: 'CESCOG | Recherche clinique',
      },
      {
        path: 'remediation-cognitive-bilan-neuropsychologique',
        loadComponent: () => import('./pages/remediation/remediation').then((m) => m.Remediation),
        title: 'CESCOG | Remédiation cognitive et bilan neuropsychologique',
      },
      {
        path: 'offres-emplois',
        loadComponent: () => import('./pages/jobs/jobs').then((m) => m.Jobs),
        title: 'CESCOG | Offres d’emplois',
      },
      {
        path: 'offres-stages',
        loadComponent: () => import('./pages/traineeship/traineeship').then((m) => m.Traineeship),
        title: 'CESCOG | Offres de stages',
      },
      {
        path: 'mentions-legales',
        loadComponent: () => import('./pages/legal-notice/legal-notice').then((m) => m.LegalNotice),
        title: 'CESCOG | Mentions légales',
      },
      {
        path: 'politique-de-confidentialite',
        loadComponent: () =>
          import('./pages/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
        title: 'CESCOG | Politique de confidentialité',
      },
      {
        path: 'conditions-generales-utilisation',
        loadComponent: () => import('./pages/cgu/cgu').then((m) => m.Cgu),
        title: 'CESCOG | Conditions générales d’utilisation',
      },
      {
        path: 'conditions-generales-ventes',
        loadComponent: () => import('./pages/cgv/cgv').then((m) => m.Cgv),
        title: 'CESCOG | Conditions générales de ventes',
      },
      {
        path: 'rendez-vous',
        loadComponent: () => import('./pages/appointment/appointment').then((m) => m.Appointment),
        title: 'CESCOG | Prendre rendez-vous',
      },
      {
        path: 'creation-compte',
        loadComponent: () =>
          import('./pages/account-creation/account-creation').then((m) => m.AccountCreation),
        title: 'CESCOG | Création de compte',
      },
      {
        path: 'connexion',
        loadComponent: () => import('./pages/log-in/log-in').then((m) => m.LogIn),
        title: 'CESCOG | Connexion',
      },
      {
        path: 'mot-de-passe-oublie',
        loadComponent: () =>
          import('./pages/lost-password/lost-password').then((m) => m.LostPassword),
        title: 'CESCOG | Mot de passe oublié',
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/reset-password/reset-password').then((m) => m.ResetPassword),
        title: 'CESCOG | Réinitialisation du mot de passe',
      },
    ],
  },
];
